import { randomString, setCookie, getCookie } from '@/common/utils/dom.js'
import { logReport } from './Log.js'
import { getToken, setToken } from '@/common/utils/cookieHandler'

function getDeviceId () {
  let deviceId = ''
  if (getCookie('deviceId')) {
    deviceId = getCookie('deviceId')
  } else {
    deviceId = randomString(32)
    setCookie('deviceId', deviceId)
  }
  return deviceId
}
// sessionId
function getSessionId () {
  let marketingSessionId = '设备不支持sessionStorage'
  try {
    if (sessionStorage.getItem('marketingSessionId')) {
      marketingSessionId = sessionStorage.getItem('marketingSessionId')
    } else {
      marketingSessionId = randomString(32)
      sessionStorage.setItem('marketingSessionId', marketingSessionId)
    }
  } catch (err) {}
  return marketingSessionId
}

function getData (obj) {
  obj.path = obj.path.indexOf('/') !== -1 ? obj.path.length > 1 ? obj.path.replace(/\//, '_') : obj.path.replace(/\//, '_') + 'index' : obj.path
  let logData = [{
    'sys': {
      'timestamp': new Date().getTime(),
      // 当前页
      'controller': obj.path,
      'appId': '888',
      'deviceId': getDeviceId(),
      'deviceInfoReferId': '',
      'appInfoReferId': '',
      'miscInfoReferId': '',
      'rguid': randomString(32),
      'platform': 'h5',
      'tag': 'marketing',
      'buildType': '',
      'serverType': '',
      'eventName': 'H5_PageEvent',
      'network': ''
    },
    'cus': {
      'userAgent': navigator.userAgent,
      'sessionId': getSessionId()
    }
  }]
  for (let key in obj) {
    logData[0].cus[key] = obj[key]
  }
  return logData
}

function handleQuery (obj) {
  if (obj.query) {
    for (let key in obj.query) {
      setToken(key, obj.query[key])
    }
    obj.query = undefined
  }
  // get channel, source and userId from cookie
  let keyArray = ['channel', 'source', 'userId']
  keyArray.map((key) => {
    obj[key] = getToken(key)
  })
}

export default function UpdateLogData (obj) {
  handleQuery(obj)
  logReport(getData(obj))
}



// WEBPACK FOOTER //
// ./src/data/api/common/Log/UpdateLogData.js